<template>
  <div :class="`settings-panel ${isOpenedSetting ? 'is-opened' : ''}`">
    <div class="menu-setting">
      <div class="menu-title" @click="clickSetting">
        <div class="setting-icon-btn">
          <SvgIcon class="setting-icon" name="IconSetting" :width=20 />
          <SvgIcon class="setting-arrow" name="IconArrowChevronLeft" :width=20 />
        </div>
        <span>{{ $t('menu_settings') }}</span>
      </div>
      <div class="menu-setting-body">
        <!-- languages  -->
        <div class="setting-section">
          <div class="setting-label">{{ $t('language') }}</div>
          <ul class="change-languages unstyle flex">
            <li>
              <button @click="lang = 'en'" :class="`lang-btn lang-en ${lang === 'en' ? 'btn-active' : 'btn-inactive'}`">
                <div v-if="lang ==='en'" class="icon-position"><Icon name="check_circle"/></div>
                <SvgIcon name="IconLangEn" :width=24 />
              </button>
            </li>
            <li>
              <button @click="lang = 'th'" :class="`lang-btn lang-th ${lang === 'th' ? 'btn-active' : 'btn-inactive'}`">
                <div v-if="lang ==='th'" class="icon-position"><Icon name="check_circle"/></div>
                <SvgIcon name="IconLangTh" :width=24 />
              </button>
            </li>
          </ul>
        </div>
        <div class="setting-section">
          <div class="setting-label">{{ $t('user_account') }}</div>
          <CncButton type="neutral" size="medium" class="btn-logout" @click="Logout">{{ $t('log_out') }}</CncButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { auth } from '../firebase'

export default {
  data () {
    const projectFontSize = '62.5%'
    const number = parseFloat(projectFontSize.replace('%', ''))
    return {
      languages: null,
      lang: this.$store.state.locale,
      isOpenedSetting: false
    }
  },
  watch: {
    'lang' (val, oldVal) {
      this.$store.commit('SET_STATE', { name: 'locale', val })
    },
    '$store.state.locale' (val, oldVal) {
      this.lang = val
    }
  },
  mounted () {
    if (this.$store.state.locales === 'en') this.lang = 'en'
  },
  methods: {
    clickSetting () {
      this.isOpenedSetting = !this.isOpenedSetting
    },
    async Logout () {
      try {
        await auth.signOut()
        sessionStorage.clear()
        this.$notify({ title: 'Signed out', type: 'success', message: 'You have been signed out.' })
        this.$router.replace('/account/login')
      } catch (error) {
        console.error('Error signing out:', error)
        this.$notify.error({ title: 'Failed to sign out', message: error.message })
      }
    }
  }
}
</script>

<style lang="scss">

.settings-panel {
  position: absolute;
  top: calc(100% - 56px);
  width: 100%;
  height: 100%;
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all;
  transition-timing-function: cubic-bezier(0.600, 0.000, 0.300, 1.000);
  transition-duration: 350ms;
  overflow-y: visible;
  background-color: white;

  &.is-opened {
    top: 0;
    padding: 20px 20px;
    overflow-y: auto;

    .menu-setting {
      .menu-title {
        span {
          font: $font-style-title-md-med;
          color: $color-cool-grey-900;
        }

        .setting-icon-btn {
          .setting-icon {
            opacity: 0;
          }
          .setting-arrow {
            opacity: 1;
          }
        }
      }
    }
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: -1px;
    left: 20px;
    right: 20px;
    height: 0;
    border-top: 1px solid $color-cool-grey-100;
  }

  .menu-setting {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .menu-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      cursor: pointer;

      &:hover {
        span {
          color: $color-cool-grey-900;
        }
        .setting-icon-btn {
          background-color: $color-cool-grey-100;
        }
      }

      span {
        font: $font-style-functional-md-reg;
        color: $color-cool-grey-700;
        flex-grow: 1;
        transition: font;
        transition-timing-function: cubic-bezier(0.600, 0.000, 0.300, 1.000);
        transition-duration: 350ms;
      }

      .setting-icon-btn {
        display: flex;
        padding: 4px;
        margin-left: -6px;
        border-radius: 999px;

        .setting-icon, .setting-arrow {
          transition: opacity;
          transition-timing-function: cubic-bezier(0.600, 0.000, 0.300, 1.000);
          transition-duration: 350ms;
        }

        .setting-arrow {
          margin-left: -20px;
          opacity: 0;
        }

        .svg-icon span {
          display: block;
          line-height: 0;
        }
      }
    }

    .menu-setting-body {
      display: flex;
      flex-direction: column;
      height: 100%;
      box-sizing: border-box;

      .setting-section{
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 16px;

        .setting-label {
          font: $font-style-functional-md-reg;
          color: $color-cool-grey-500;
        }
      }

      ul.change-languages {
        align-items: center;
        gap: 12px;

        .lang-btn {
          position: relative;
          display: block;
          height: 56px;
          width: 100%;
          align-items: center;
          padding: 8px 12px 8px 16px;
          border-radius: $border-radius-lg;

          &.btn-active {
            background-color: $color-primary-50;

            &.lang-en svg path {
              stroke: $color-primary-500;
            }

            &.lang-th svg path {
              fill: $color-primary-500;
            }

            &:hover {
              background-color: $color-primary-100;
            }
          }

          &.btn-inactive {
            background-color: $color-white;

            &.lang-en svg path {
              stroke: $color-cool-grey-500;
            }

            &.lang-th svg path {
              fill: $color-cool-grey-500;
            }

            &:hover {
              background-color: $color-cool-grey-50;
            }
          }

          .icon-position {
            position: absolute;
            top: 8px;
            right: 8px;
            color: $color-primary-500;
          }
        }
      }

      .btn-logout {
        div {
          padding: 0px 12px 8px 16px;
          color: $color-cool-grey-700
        }
      }
    }
  }
}
</style>
